export const StaticImplements =
  <T>() =>
  <U extends T>(constructor: U) => {
    constructor;
  };

export interface Factory<T> {
  fromJson(json: Partial<T>): T;
}

export type KeysOfType<T, TProp> = { [P in keyof T]: T[P] extends TProp ? P : never }[keyof T];
export const stringFormatter = (
  str: string,
  espacamento?: boolean,
  upperCase: boolean = true,
  underLine: boolean = true,
): string =>
  (str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/([^\w]+|\s+)/g, underLine ? '_' : espacamento ? ' ' : '') // Substitui espaço e outros caracteres por "_" ou espaço em branco ou vazio
    .trim()
    [upperCase ? 'toUpperCase' : 'toLowerCase']() || ''; // Formata para upper case
